export default __webpack_public_path__ + "static/8-bd286b08670189a91369dd7f62fbe5f5.png";